package com.nonopn.geolocation

import dev.jordond.compass.geolocation.Geolocator
import dev.jordond.compass.geolocation.browser

internal actual fun createLocator(): Geolocator =
    Geolocator.browser()
